/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

export default function CategorySidebar({
    categories,
    activeCategory,
    setActiveCategory
}) {

    return (

        <aside className="
            hidden lg:block
            w-64
            border-r
            border-zinc-800
            p-6
            sticky
            top-0
            h-screen
        ">

            <h3 className="text-sm uppercase text-zinc-500 mb-4">
                Categories
            </h3>

            <div className="space-y-2">

                {categories.map((category) => (

                    <button
                        key={category}
                        onClick={() => setActiveCategory(category)}
                        className={`
                            w-full
                            text-left
                            px-4
                            py-3
                            rounded-xl
                            transition-all
                            ${
                                activeCategory === category
                                ? "bg-emerald-500 text-black"
                                : "bg-zinc-900 hover:bg-zinc-800"
                            }
                        `}
                    >
                        {category}
                    </button>

                ))}

            </div>

        </aside>
    );
}